
import { Component, Prop, Vue, Provide, Watch } from 'vue-property-decorator';
import moment from 'moment';
import Workflow from '../assets/ts/Workflow';

@Component({})
export default class WorkflowAudit extends Vue {
    private isLoading: any = false; // 控制按钮重复点击
    private Remark: any = ''; // 备注
    private AuditEntity: any = {}; // 审核时所传参数
    @Prop() private requireRemark: any; // 获取到是否备注必填---true必填---false非必填
    @Prop() private workFlowData: any; // 获取到的审核信息
    @Prop() private WorkflowItemCode: any; // 获取到的审核CODE

    private audit(item: any) {
        this.$toast.loading({
            mask: true,
            message: '提交中...',
            duration: 0,
        });
        Workflow.Audit(this.WorkflowItemCode, this.workFlowData.TargetEntityId, item.Code, this.Remark ? this.Remark : '无', (response: any) => {
            if (response.Success) {
                this.$toast.clear();
                this.isLoading = true;
                this.$emit('change', response.Data);
            } else {
                this.$toast.clear();
                this.isLoading = true;
                this.$dialog.alert({
                    title: '错误',
                    message: response.AllMessages,
                });
            }
        }, (error: any) => {
            console.log(error);
        });
    }
}
